import * as React from "react";
import type { UserDTO } from "groopit-js";
import Modal from "react-modal";

export interface LikeProps {
  groopit: string;
  likedByUser: string;
  likesCount: number;
  canComment: boolean;
}

export interface LikeState {
  liked: boolean;
  likeCount: number;
  isOpen: boolean;
  likedBy?: UserDTO[];
}

export class LikeContainer extends React.Component<LikeProps, LikeState> {
  /**
   *
   */
  constructor(props: LikeProps) {
    super(props);
    this.state = {
      liked: props.likedByUser == "True",
      likeCount: props.likesCount,
      isOpen: false,
    };
  }

  //
  // Toggle whether the current user has liked this groopit or not.
  //
  private handleLike(e: React.SyntheticEvent) {
    e.preventDefault();

    const like = !this.state.liked;

    this.setState((state) => ({
      liked: like,
      likeCount: like ? state.likeCount + 1 : state.likeCount - 1,
    }));
    import("groopit-js").then((m) => {
      const client = new m.GroopItApiClient({
        getXSRFToken: () =>
          (
            document.getElementsByName(
              "__RequestVerificationToken",
            )[0] as HTMLInputElement
          ).value,
      });
      client
        .likeGroopIt(this.props.groopit, new m.GroopItLike({ like }))
        .catch((error) => {
          if (error instanceof m.ApiException) {
            if (error.status === 401 || error.status === 403) {
              window.location.href =
                "/Account/Login?returnUrl=" +
                encodeURIComponent(window.location.href);
              return;
            }
          }
        });
    });
  }

  //
  // Load the list of users who have liked the groopit when the dialog gets opened
  //
  private dlgOpen = () => {
    import("groopit-js").then((m) => {
      const client = new m.GroopItApiClient({});
      client
        .getLikes(this.props.groopit)
        .then((users) => {
          this.setState({ likedBy: users });
        })
        .catch((error) => {
          if (error instanceof m.ApiException) {
            if (error.status === 401 || error.status === 403) {
              window.location.href =
                "/Account/Login?returnUrl=" +
                encodeURIComponent(window.location.href);
              return;
            }
          }
        });
    });
  };

  render(): JSX.Element {
    let likeDesc = "";
    if (this.state.liked) {
      if (this.state.likeCount == 1) {
        likeDesc = "You like this data.";
      } else if (this.state.likeCount == 2) {
        likeDesc = "You and 1 other user like this data.";
      } else {
        likeDesc =
          "You and " +
          (this.state.likeCount - 1) +
          " other users like this data.";
      }
    } else {
      if (this.state.likeCount == 1) {
        likeDesc = "1 other user likes this data.";
      } else if (this.state.likeCount > 1) {
        likeDesc = "" + this.state.likeCount + " other users like this data.";
      }
    }
    const captionStyle = {
      verticalAlign: "text-top",
      marginLeft: "4px",
    };
    const imgStyle = { height: "16px", maxWidth: "16px" };
    return (
      <div>
        <LikeButton
          liked={this.state.liked}
          onClick={this.handleLike.bind(this)}
        />
        <a
          className="text-display-caption text-color-hint"
          href="#"
          data-toggle="modal"
          data-target={this.props.groopit + "-likes"}
          onClick={(e) => {
            e.preventDefault();
            this.setState({ isOpen: true });
          }}
          style={captionStyle}
        >
          {likeDesc}
        </a>
        {this.props.canComment && (
          <a
            className="pull-right"
            href={"/GroopIt/Details/" + this.props.groopit}
          >
            <img
              src="/Content/Images/comment.png"
              className="glyphicon glyphicon-comment text-color-primary"
              style={imgStyle}
            />
          </a>
        )}
        <Modal
          style={{
            overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
            content: {
              height: "fit-content",
              margin: "30px auto",
              maxWidth: "600px",
            },
          }}
          contentLabel="Likes"
          isOpen={this.state.isOpen}
          onAfterOpen={this.dlgOpen}
          onRequestClose={() => {
            this.setState({ isOpen: false });
          }}
        >
          <h4 className="modal-title text-display-title text-color-primary">
            Likes
          </h4>
          <div className="modal-body">
            {this.state.likedBy == null ? (
              <div className="loader" style={{ margin: "0 auto" }}></div>
            ) : (
              this.state.likedBy.map((u) => (
                <div key={u.id} className="flex items-center">
                  <img src={u.avatarUrl} className="avatar-img m-1" />
                  <div className="text-display-normal text-color-secondary">
                    {u.friendlyName}
                  </div>
                </div>
              ))
            )}
          </div>
          <div className="modal-footer">
            <button
              onClick={() => {
                this.setState({ isOpen: false });
              }}
              type="button"
              className="btn btn-accent"
            >
              Close
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

export class LikeButton extends React.Component<{
  liked: boolean;
  onClick: (event: React.SyntheticEvent) => void;
}> {
  render(): JSX.Element {
    let likeClass: string;
    if (this.props.liked) {
      likeClass = "glyphicon heart like-icon";
    } else {
      likeClass = "glyphicon heart-empty like-icon";
    }
    return (
      <a onClick={this.props.onClick} className="icon">
        <span className={likeClass}></span>
      </a>
    );
  }
}

Modal.setAppElement("body");
